import { useState, useEffect } from 'react';

import fetchRequest from '../utils/fetchRequest';

const useGetActivationSubs = () => {
  const [subs, setSubs] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadSubs = async () => {
    try {
      setLoading(true);
      const response = await fetchRequest.get(
        '/subscriptions/subs_for_activation',
      );
      setSubs(response.data?.subs);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSubs();
  }, []);

  return [subs, loading, loadSubs];
};

export default useGetActivationSubs;
